const STATS = [
  { value: '200+', label: 'Active Members' },
  { value: '10+',  label: 'Expert Coaches' },
  { value: '5+',   label: 'Disciplines' },
  { value: '6',    label: 'Days a Week' },
];

const FEATURES = [
  {
    icon: 'ri-trophy-line',
    title: 'Strength & Power',
    desc: 'Powerlifting, functional fitness, and heavy compound movements for serious athletes.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Calisthenics',
    desc: 'Advanced bodyweight skill development with dedicated equipment and space.',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'For Everyone',
    desc: 'CrossFit, functional training, and traditional gym — all disciplines welcome.',
  },
];

export default function About() {
  return (
    <section id="about" className="bg-[#111111]">
      <div className="max-w-7xl mx-auto px-6 lg:px-16 py-24 lg:py-36">

        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-16 gap-8">
          <div>
            <span data-animate className="inline-flex items-center gap-2 text-[#14B8A6] text-xs tracking-widest font-medium mb-4">
              <span className="w-4 h-px bg-[#14B8A6]" />
              ABOUT US
            </span>
            <h2 data-animate data-delay="1" className="text-white text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
              A Serious Training<br />Environment
            </h2>
          </div>

          <div className="lg:max-w-md">
            <p data-animate data-delay="2" className="text-gray-400 text-base lg:text-lg leading-relaxed">
              HUB30 is Jbeil's fully equipped training center — built for athletes and everyday members alike. CrossFit, calisthenics, strength, physiotherapy, and more. Everything you need, no limits.
            </p>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden mb-20">
          {STATS.map(({ value, label }, i) => (
            <div
              key={label}
              data-animate
              data-delay={i + 1}
              className="bg-[#111111] px-6 py-8 flex flex-col items-center text-center"
            >
              <span className="text-3xl lg:text-4xl font-bold text-[#14B8A6] mb-1">{value}</span>
              <span className="text-gray-400 text-xs tracking-wide uppercase">{label}</span>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-white/10 mb-20" />

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {FEATURES.map(({ icon, title, desc }, i) => (
            <div
              key={title}
              data-animate
              data-delay={(i + 2) as 2 | 3 | 4}
              className="group relative bg-[#1a1a1a] rounded-2xl p-8 border border-white/[0.06] hover:border-[#14B8A6]/30 transition-all duration-300"
            >
              {/* Icon */}
              <div className="w-12 h-12 rounded-xl bg-[#14B8A6]/10 flex items-center justify-center mb-6 group-hover:bg-[#14B8A6]/20 transition-colors">
                <i className={`${icon} text-[#14B8A6] text-xl`} />
              </div>
              <h3 className="text-white text-xl font-bold mb-3">{title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{desc}</p>

              {/* Bottom accent line on hover */}
              <span className="absolute bottom-0 left-8 right-8 h-px bg-[#14B8A6]/0 group-hover:bg-[#14B8A6]/30 transition-all duration-300 rounded-full" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
